import { Fragment } from 'react';
import { useBladeStack } from './BladeStackProvider';

// Path rail (HUB-275) — the blade stack rendered as a breadcrumb, driven by the
// reducer. Clicking a crumb activates that blade (and, in focus mode, focuses it).
// Uses the `.breadcrumb`/`.crumb` chrome ported from the mockup in shell.css.

/** Lucide "chevron-right" separator. */
function Chevron() {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
      <path d="m9 18 6-6-6-6" />
    </svg>
  );
}

export function Breadcrumb() {
  const { state, dispatch } = useBladeStack();
  if (state.blades.length === 0) return null;

  return (
    <nav className="breadcrumb" aria-label="Blade path">
      {state.blades.map((blade, i) => (
        <Fragment key={i}>
          {i > 0 && (
            <span className="crumb-sep" aria-hidden>
              <Chevron />
            </span>
          )}
          <button
            type="button"
            className={i === state.activeIndex ? 'crumb active' : 'crumb'}
            aria-current={i === state.activeIndex ? 'page' : undefined}
            onClick={() => dispatch({ type: 'activate', index: i })}
          >
            {blade.eyebrow && <span className="ctype">{blade.eyebrow}</span>}
            <span>{blade.title}</span>
          </button>
        </Fragment>
      ))}
    </nav>
  );
}
